import { render, staticRenderFns } from "./PrestadoresPendentesJustificativaDownload.vue?vue&type=template&id=60886e00"
import script from "./PrestadoresPendentesJustificativaDownload.vue?vue&type=script&lang=js"
export * from "./PrestadoresPendentesJustificativaDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports